import styled from '@emotion/styled';
import { Box, BoxProps, createPolymorphicComponent } from '@mantine/core';

export const PageContainer = createPolymorphicComponent<'div', BoxProps>(styled(Box)`
  display: flex;
  flex-direction: column;
  min-height: 100%;
`);

export const PageContent = createPolymorphicComponent<'div', BoxProps>(styled(Box)`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100%;
  margin: 0 auto;
`);

export const PageBottom = styled.div`
  position: sticky;
  bottom: 0;
  margin-top: auto;
`;

export const PageBottomBar = styled.div`
  display: flex;
  justify-content: center;
  flex: 0 0 auto;
  width: 100%;
  padding: 20px;
  background-image: linear-gradient(to bottom, transparent, ${({ theme }) => theme.colors.background[1]} 90%);
`;
